import app from '@/app';

/* @ngInject */
function Test($resource) {
	return $resource(
		'api/tests/:id',
		{ id: '@id' },
		{
			query: { method: 'GET' },
			purge: { method: 'DELETE' }
		}
	);
}

app.factory('Test', Test);
